let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eTO74")).then(() => parcelRequire('655M4'));